"use client";

import { useEffect, useState } from "react";

const imagePaths = [
  "/images/community/employee-giving-1.jpg.jpeg",
  "/images/community/employee-giving-2.jpg.jpeg",
  "/images/community/employee-giving-3.jpg.jpeg",
  "/images/community/employee-giving-4.jpg.jpeg?v=2",
];

export function EmployeeGivingGallery() {
  const [index, setIndex] = useState(0);

  const handleNext = () => {
    setIndex((prev) => (prev + 1) % imagePaths.length);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % imagePaths.length);
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4 flex flex-col items-center">
        <a
          href="https://mackaycommunityfoundation.com/wp-content/uploads/2026/02/MCF-Employee-Giving-Program.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="mb-6 max-w-3xl text-base font-medium text-body-color text-center underline-offset-4 hover:underline"
        >
          The Mackay Community Foundation’s Employee Giving Program empowers local businesses and their teams to make a lasting impact by contributing small, regular donations that are invested to support community grants year after year. By giving where we live, participants help fund vital initiatives across the region—creating sustainable change today and for generations to come.
        </a>
        <div className="flex w-full max-w-5xl flex-col items-center gap-3 sm:flex-row sm:items-center sm:justify-between mb-4">
          <span className="text-sm font-medium text-body-color text-center sm:text-left">
            Learn more ({index + 1} of {imagePaths.length})
          </span>
          <div className="flex gap-3">
            <a
              href="https://mackaycommunityfoundation.com/donate-now/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center rounded-md border border-primary px-4 py-2 text-sm font-semibold text-primary hover:bg-primary/5"
            >
              Donate Now
            </a>
            <button
              type="button"
              onClick={handleNext}
              className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-primary/90"
            >
              Next page
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={handleNext}
          className="block w-full max-w-5xl overflow-hidden rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          aria-label="Show next Employee Giving page"
        >
          <div className="relative w-full" style={{ paddingBottom: "90%" }}>
            <img
              src={imagePaths[index]}
              alt={`Employee Giving program page ${index + 1}`}
              className="absolute inset-0 h-full w-full object-contain bg-white"
              loading="lazy"
            />
          </div>
        </button>
      </div>
    </section>
  );
}
